import { Injectable } from '@angular/core';
import { RestProviderActionHandlers } from './rest-provider-action-handlers';

@Injectable()
export class MockProviderActionHandlers extends RestProviderActionHandlers {}
